import api from './api';

// Upload single file (logo or main image)
export const uploadFile = async (file, type = 'single') => {
  try {
    const formData = new FormData();
    const fieldName = type === 'logo' ? 'logo' : (type === 'banner' ? 'bannerImage' : 'mainImage');
    formData.append(fieldName, file);

    const endpoint = type === 'logo' ? 'logo' : (type === 'banner' ? 'banner' : 'single');
    const response = await api.post(`/api/upload/${endpoint}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });

    return {
      success: true,
      url: response.data.data.url,
      filename: response.data.data.filename
    };
  } catch (error) {
    console.error('Upload error:', error);
    return {
      success: false,
      message: error.response?.data?.message || 'Error uploading file'
    };
  }
};

// Upload multiple files (sub images)
export const uploadMultipleFiles = async (files) => {
  try {
    const formData = new FormData();
    Array.from(files).forEach(file => {
      formData.append('subImages', file);
    });

    const response = await api.post('/api/upload/multiple', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });

    return {
      success: true,
      urls: response.data.data.files.map(f => f.url),
      files: response.data.data.files
    };
  } catch (error) {
    console.error('Upload error:', error);
    return {
      success: false,
      message: error.response?.data?.message || 'Error uploading files'
    };
  }
};

